import React, { useEffect } from "react";
import { Link } from "gatsby";
import { motion, useAnimation } from "framer-motion";
import { InView, useInView } from "react-intersection-observer";
import { transform } from "lodash";

const About = class extends React.Component {
  render() {
    return (
      <section className="home-about" id="about">
        <div className="container">
          <div className="why">
            <InView threshold={0.2}>
              {({ ref, inView }) => (
                <motion.h3
                  ref={ref}
                  initial={{ opacity: 0, transform: "translate(-50px)" }}
                  animate={
                    inView
                      ? { opacity: 1, transform: "translate(0px)" }
                      : { opacity: 0 }
                  }
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    duration: 3,
                    delay: 0.25,
                  }}
                >
                  Why Opal?
                </motion.h3>
              )}
            </InView>
          </div>
          <div className="title">
            <InView threshold={0.2}>
              {({ ref, inView }) => (
                <motion.h2
                  ref={ref}
                  initial={{ opacity: 0, transform: "translate(-50px)" }}
                  animate={
                    inView
                      ? { opacity: 1, transform: "translate(0px)" }
                      : { opacity: 0 }
                  }
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    duration: 3,
                    delay: 0.25,
                  }}
                >
                  The reason why we’re good at what we do is because we know
                  lots of people who are{" "}
                  <span className="highlight">just like you</span>.
                </motion.h2>
              )}
            </InView>
          </div>
          <div className="about">
            <InView threshold={0.2}>
              {({ ref, inView }) => (
                <motion.p
                  ref={ref}
                  initial={{ opacity: 0, transform: "translate(50px)" }}
                  animate={
                    inView
                      ? { opacity: 1, transform: "translate(0px)" }
                      : { opacity: 0 }
                  }
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    duration: 3,
                    delay: 0.25,
                  }}
                >
                  We’ve spent many years immersing ourselves within the ux and creative industries, building a network of relationships with the curious, ambitious, and the big-picture thinkers. People that want to leave their mark and demonstrate passion for their craft.
                </motion.p>
              )}
            </InView>
            <br />
            <InView threshold={0.2}>
              {({ ref, inView }) => (
                <motion.p
                  ref={ref}
                  initial={{ opacity: 0, transform: "translate(50px)" }}
                  animate={
                    inView
                      ? { opacity: 1, transform: "translate(0px)" }
                      : { opacity: 0 }
                  }
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    duration: 3,
                    delay: 0.25,
                  }}
                >
                  We operate in your circles and associate with your people.
                  Building a network that feeds us valuable daily market
                  research, that’s hot-off-the-press and bang up to date.
                  Insights that’ll provide you with opportunities to support
                  your search and give you an edge over your competition.
                </motion.p>
              )}
            </InView>
          </div>
        </div>
      </section>
    );
  }
};

export default About;
